import { useState } from 'react';
import { useGetScheduleNotificationBannerStatus } from './useGetScheduleNotificationBannerStatus';
import { useScheduleNotificationBannerDismissal } from './useScheduleNotificationBannerDismissal';

type ReturnType = {
  /** バナーを表示するかどうか */
  isVisible: boolean;
  /** バナーを閉じる */
  onClose: () => void;
};

/**
 * ストレスチェック実施バナーの表示制御を行うオーケストレーションhook。
 * サーバーフラグとlocalStorageスヌーズを組み合わせて表示判定を行う。
 */
export const useScheduleNotificationBanner = (): ReturnType => {
  const { isDisplayBanner } = useGetScheduleNotificationBannerStatus();
  const { isSnoozed, dismiss } = useScheduleNotificationBannerDismissal();

  // 閉じた直後に再レンダーを待たずに即時非表示にするためのローカルstate
  const [isDismissed, setIsDismissed] = useState(false);

  const isVisible = isDisplayBanner && !isSnoozed && !isDismissed;

  const onClose = () => {
    dismiss();
    setIsDismissed(true);
  };

  return { isVisible, onClose };
};
